const defaultEventConfig = require('cloud-utils/config/events/default.json')
const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  defaultEventConfig.deviceEventSettings
)
const SemVerGte = require('semver/functions/gte')
const SemVerLte = require('semver/functions/lte')
const SemverSatifies = require('semver/functions/satisfies')

angular
  .module('surfsightApp.controllers')
  .controller('EdgeEventSettingsController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    '$mdSidenav',
    'edgeFactory',
    'dataFromCaller',
    'nominatimLookUp',
    '$filter',
    '$rootScope',
    'SystemConstants',
    'UnitSystem',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      $mdSidenav,
      edgeFactory,
      dataFromCaller,
      nominatimLookUp,
      $filter,
      $rootScope,
      SystemConstants,
      UnitSystem
    ) {
      $scope.UnitSystem = UnitSystem
      if ($localStorage.measurementUnits === 1) {
        SystemConstants.unit = 1
      } else {
        SystemConstants.unit = 0
      }
      let semanticVersion = null
      const snapshotSupportFromVersion = '3.7.7'
      $scope.deviceAbilities = {
        snapshot: false
      }
      $scope.version = {}
      const {
        bulkDevicesSelections,
        isBulkDeviceSelection,
        edge_list
      } = dataFromCaller
      $scope.data = $rootScope.data
      $scope.edge = dataFromCaller.edge
      if ($scope.edge && !$scope.edge.deviceModel) {
        $scope.edge.deviceModel = /^8/.test($scope.edge.imei)
          ? 'AI-14'
          : 'AI-12'
      }
      $scope.isDeviceSupportCalibration =
        !isBulkDeviceSelection && dataFromCaller.edge.deviceModel === 'AI-12'
      $scope.isBulkDeviceSelection = isBulkDeviceSelection
      $scope.deviceTitle = isBulkDeviceSelection
        ? 'Bulk Edit'
        : $scope.edge.name
      $scope.serialNumber = dataFromCaller.edge && dataFromCaller.edge.imei
      $scope.proxyStatus = true
      $scope.selectedTab = 0
      const $translate = $filter('translate')
      $scope.carTypes = [
        {
          id: 'Private',
          name: 'private'
        },
        {
          id: 'Van',
          name: 'van'
        },
        {
          id: 'Trailer',
          name: 'trailer'
        }
      ]
      $scope.vehicleType = {
        value: $scope.carTypes[0].id
      }
      $scope.systemVersion = function () {
        $scope.loading = true
        const requestJson = {
          method: 'GET',
          url: `${DEVICEMANAGER_BASEURL}/device/${$scope.serialNumber}/version`
        }
        $http(requestJson).then(
          function (response) {
            $scope.requestResponseCode = response.data.status.code
            if (response.data.system_version) {
              semanticVersion = response.data.system_version.semantic_version
              $scope.deviceAbilities.snapshot =
                !semanticVersion ||
                SemVerGte(semanticVersion, snapshotSupportFromVersion)
            }
            $scope.loadEdgeEventSettings()
          },
          function (response) {
            handleServerError(response)
            $scope.showMessageToast(response.data.status.error)
          }
        )
      }
      $scope.loadEdgeEventSettings = async function () {
        $scope.loading = true
        const requestJson = {
          method: 'GET',
          url: `${DEVICEMANAGER_BASEURL}/device/${$scope.serialNumber}/trigger_config`
        }
        const { data } = await loadADASCalibrationData($scope.serialNumber)
        let isAdasCalibrated = false
        if (data && Array.isArray(data.devices) && data.devices.length === 1) {
          isAdasCalibrated = data.devices[0].adasCalibrated
        }
        $http(requestJson)
          .then(function (response) {
            if (response.data.status.code === 0) {
              const { triggers } = response.data
              if (triggers.length > 0) {
                ;({ vehicle_type: $scope.vehicleType.value } = triggers.find(
                  t => t.trigger_type === 'VehicleSettings'
                ))
                $scope.available_edge_event_settings.forEach(function (e, i) {
                  $scope.available_edge_event_settings[i].index = i
                  $scope.available_edge_event_settings[i].status = 'off'
                  $scope.available_edge_event_settings[
                    i
                  ].isAdasCalibrated = isAdasCalibrated
                  const trigger = triggers.find(t => t.trigger_type === e.name)
                  if (trigger) {
                    $scope.available_edge_event_settings[i].status =
                      trigger.data_type || 'video'
                    if (e.isSpeedLimit) {
                      $scope.available_edge_event_settings[
                        i
                      ].speed_limit = Math.ceil(
                        UnitSystem.value(
                          parseInt(trigger.speed_limit),
                          'km/h',
                          '$v'
                        )
                      )
                    }
                    if (e.isPossibleFatigue) {
                      $scope.available_edge_event_settings[
                        i
                      ].driving_duration = parseInt(trigger.driving_duration)
                    }
                    if (trigger.config) {
                      $scope.available_edge_event_settings[i].config =
                        trigger.config
                    }
                  }
                  const {
                    fromVersion,
                    toVersion,
                    audioAlert,
                    visualAlert,
                    numberOfBeeps,
                    minimumSpeed,
                    versionRanges
                  } = $scope.available_edge_event_settings[i]
                  $scope.available_edge_event_settings[i].hide =
                    fromVersion && semanticVersion
                      ? !SemVerGte(semanticVersion, fromVersion) ||
                        (toVersion && SemVerGte(semanticVersion, toVersion))
                      : false
                  if (
                    ($scope.available_edge_event_settings[i].name ===
                      'driverChangeDetection' ||
                      $scope.available_edge_event_settings[i].name ===
                        'unfamiliardriver') &&
                    versionRanges &&
                    semanticVersion
                  ) {
                    $scope.available_edge_event_settings[
                      i
                    ].hide = !SemverSatifies(semanticVersion, versionRanges)
                  }
                  $scope.available_edge_event_settings[i].hide =
                    $scope.available_edge_event_settings[i].hide ||
                    ($scope.available_edge_event_settings[i].name === 'yawn' &&
                      !$scope.edge.isYawnEvFeatureEnabledForPartnerOfDevice)
                  if ($scope.available_edge_event_settings[i].hide) {
                    $scope.available_edge_event_settings[i].status = 'off'
                  }
                  let showOptions = false
                  if (e.optionalParameters.available) {
                    if (e.optionalParameters.supportedFromVersion) {
                      showOptions =
                        !semanticVersion ||
                        SemVerGte(
                          semanticVersion,
                          e.optionalParameters.supportedFromVersion
                        )
                    } else {
                      showOptions = true
                    }
                    if (e.optionalParameters.availableOffline === false) {
                      showOptions =
                        showOptions &&
                        $scope.edge.proxy_connected &&
                        !$scope.edge.standby
                    }
                  }
                  $scope.available_edge_event_settings[
                    i
                  ].showOptions = showOptions

                  $scope.available_edge_event_settings[
                    i
                  ].isAudioAlertAvailable = audioAlert
                    ? (!window.MAX_SUPPORTED_DEVICE_VERSION ||
                        SemVerGte(
                          window.MAX_SUPPORTED_DEVICE_VERSION,
                          audioAlert.fromVersion
                        )) &&
                      (!semanticVersion ||
                        SemVerGte(semanticVersion, audioAlert.fromVersion))
                    : false

                  if (
                    $scope.available_edge_event_settings[i]
                      .isAudioAlertAvailable &&
                    $scope.available_edge_event_settings[i].status !== 'off'
                  ) {
                    $scope.available_edge_event_settings[i].audio_alert =
                      trigger.audio_alert
                  }

                  $scope.available_edge_event_settings[
                    i
                  ].isVisualAlertAvailable = visualAlert
                    ? (!window.MAX_SUPPORTED_DEVICE_VERSION ||
                        SemVerGte(
                          window.MAX_SUPPORTED_DEVICE_VERSION,
                          visualAlert.fromVersion
                        )) &&
                      (!semanticVersion ||
                        SemVerGte(semanticVersion, visualAlert.fromVersion))
                    : false

                  if (
                    $scope.available_edge_event_settings[i]
                      .isVisualAlertAvailable &&
                    $scope.available_edge_event_settings[i].status !== 'off'
                  ) {
                    $scope.available_edge_event_settings[i].visual_alert =
                      trigger.visual_alert
                  }

                  if (
                    $scope.available_edge_event_settings[i].name ===
                      'fatigue' &&
                    SemVerGte(semanticVersion, fromVersion)
                  ) {
                    $scope.available_edge_event_settings[i].status = trigger
                      ? trigger.data_type
                      : 'off'
                    $scope.available_edge_event_settings[
                      i
                    ].isAudioAlertAvailable = false
                    $scope.available_edge_event_settings[
                      i
                    ].isVisualAlertAvailable = false
                    $scope.available_edge_event_settings[
                      i
                    ].isFatigueEnabled = true
                  }

                  if (
                    $scope.available_edge_event_settings[i].name ===
                      'possibleFatigue' &&
                    !SemVerLte(semanticVersion, toVersion)
                  ) {
                    $scope.available_edge_event_settings[
                      i
                    ].isPossibleFatigue = false
                  }

                  $scope.available_edge_event_settings[
                    i
                  ].isNumberOfBeepsAvailable = numberOfBeeps
                    ? semanticVersion &&
                      SemverSatifies(
                        semanticVersion,
                        numberOfBeeps.versionRanges
                      ) &&
                      $scope.available_edge_event_settings[i].status !== 'off'
                    : false
                  if (
                    $scope.available_edge_event_settings[i]
                      .isNumberOfBeepsAvailable &&
                    $scope.available_edge_event_settings[i].status !== 'off'
                  ) {
                    const minBeep =
                      trigger.numberOfBeeps !== undefined
                        ? trigger.numberOfBeeps
                        : numberOfBeeps.defaultValue

                    const { allowedValueRange, incrementBy } = numberOfBeeps
                    const allowedValues = window.getRange(
                      allowedValueRange[0],
                      allowedValueRange[1],
                      incrementBy
                    )
                    $scope.available_edge_event_settings[
                      i
                    ].numberOfBeeps.value = minBeep

                    $scope.available_edge_event_settings[
                      i
                    ].numberOfBeeps.allowedValues = allowedValues
                  }
                  $scope.available_edge_event_settings[
                    i
                  ].isMinimumSpeedAvailable = minimumSpeed
                    ? semanticVersion &&
                      SemverSatifies(
                        semanticVersion,
                        minimumSpeed.versionRanges
                      ) &&
                      $scope.available_edge_event_settings[i].status !== 'off'
                    : false
                  if (
                    $scope.available_edge_event_settings[i]
                      .isMinimumSpeedAvailable &&
                    $scope.available_edge_event_settings[i].status !== 'off'
                  ) {
                    const minSpeed =
                      trigger.minimumSpeed !== undefined
                        ? trigger.minimumSpeed
                        : minimumSpeed.defaultValue

                    const { allowedValueRange } = minimumSpeed

                    $scope.available_edge_event_settings[
                      i
                    ].minimumSpeed.value = Math.ceil(
                      UnitSystem.value(parseInt(minSpeed), 'km/h', '$v')
                    )

                    $scope.available_edge_event_settings[
                      i
                    ].minimumSpeed.minValue = allowedValueRange[0]
                    $scope.available_edge_event_settings[
                      i
                    ].minimumSpeed.maxValue = allowedValueRange[1]
                  }
                })
              }
            }
          })
          .catch(error => {
            console.error(error)
            if (error.data && error.data.statusCode === 403) {
              $scope.cancel()
            }
            handleServerError(error)
          })
          .finally(() => {
            $scope.loading = false
          })
      }
      if (isBulkDeviceSelection) {
        $scope.deviceAbilities = {
          snapshot: true
        }

        const yawnEventConfig = deviceEventSettings.find(e => e.name === 'yawn')

        let selectedDevices = bulkDevicesSelections.devices
        bulkDevicesSelections.groupIds.forEach(gId => {
          selectedDevices = selectedDevices.concat(
            edge_list.filter(e => e.groupId === gId)
          )
        })
        let isAI14 = true
        let isAI12 = true

        let actualSelectedDevice = selectedDevices
        if (
          bulkDevicesSelections.groupIds &&
          bulkDevicesSelections.groupIds.length === 1 &&
          bulkDevicesSelections.groupIds.includes(-1)
        ) {
          const unSelectedDevices = bulkDevicesSelections.groups.find(
            group => group.groupId === -1
          )
          actualSelectedDevice = selectedDevices.filter(device => {
            return !unSelectedDevices.excludeSerialNumbers.includes(device.imei)
          })
        }
        actualSelectedDevice.forEach(device => {
          if (device.deviceModel === 'AI-12') isAI14 = false
          if (device.deviceModel === 'AI-14') isAI12 = false
        })
        const isYawnShouldBeVisible = selectedDevices.some(device => {
          return (
            device.isYawnEvFeatureEnabledForPartnerOfDevice &&
            SemVerGte(device.firmwareVersion, yawnEventConfig.fromVersion) &&
            SemVerLte(device.firmwareVersion, yawnEventConfig.toVersion)
          )
        })
        if (isAI14) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent($translate('limitedEventSupportInfo'))
              .action($translate('ok'))
              .highlightAction(true)
              .position('bottom right')
              .hideDelay(5000)
          )
        }
        $scope.available_edge_event_settings = deviceEventSettings
          .filter(e => {
            if (e.name === 'yawn' && !isYawnShouldBeVisible) {
              return false
            }
            if (
              isAI14 &&
              (e.name === 'tailgating' ||
                e.name === 'passenger_unbelted' ||
                e.name === 'lane_weaving' ||
                e.name === 'yawn' ||
                e.name === 'cover_opened' ||
                e.name === 'power_disconnect_alarm' ||
                e.name === 'jolt')
            ) {
              return false
            }
            if (
              isAI12 &&
              (e.name === 'rollingStop' ||
                e.name === 'criticalDistance' ||
                e.name === 'followingDistance' ||
                e.name === 'thermalControl' ||
                e.name === 'ignitionOff' ||
                e.name === 'ignitionOn' ||
                e.name === 'fatigue')
            ) {
              return false
            }
            return e.fromVersion
              ? SemVerGte(dataFromCaller.maxFirmwareVersion, e.fromVersion) &&
                  (!e.configure ||
                    e.configure.allowInBulkUI === undefined ||
                    e.configure.allowInBulkUI)
              : true
          })
          .map(setting => ({
            ...setting,
            status: 'off',
            ...(setting.isSpeedLimit && { speed_limit: -1 }),
            ...(setting.defaultConfiguration && {
              ...setting.defaultConfiguration
            }),
            ...(setting.defaultConfiguration && {
              config: setting.defaultConfiguration
            }),
            isAudioAlertAvailable:
              setting.name === 'fatigue'
                ? false
                : setting.audioAlert
                ? !window.MAX_SUPPORTED_DEVICE_VERSION ||
                  SemVerGte(
                    window.MAX_SUPPORTED_DEVICE_VERSION,
                    setting.audioAlert.fromVersion
                  )
                : false,
            isVisualAlertAvailable:
              setting.name === 'fatigue'
                ? false
                : setting.visualAlert
                ? !window.MAX_SUPPORTED_DEVICE_VERSION ||
                  SemVerGte(
                    window.MAX_SUPPORTED_DEVICE_VERSION,
                    setting.visualAlert.fromVersion
                  )
                : false,
            isNumberOfBeepsAvailable: !!setting.numberOfBeeps,
            ...(setting.numberOfBeeps && {
              numberOfBeeps: {
                ...setting.numberOfBeeps,
                value: setting.numberOfBeeps.defaultValue,
                allowedValues: window.getRange(
                  setting.numberOfBeeps.allowedValueRange[0],
                  setting.numberOfBeeps.allowedValueRange[1],
                  setting.numberOfBeeps.incrementBy
                )
              }
            }),
            isMinimumSpeedAvailable: !!setting.minimumSpeed,
            ...(setting.minimumSpeed && {
              minimumSpeed: {
                ...setting.minimumSpeed,
                value: setting.minimumSpeed.defaultValue,
                minValue: setting.minimumSpeed.allowedValueRange[0],
                maxValue: setting.minimumSpeed.allowedValueRange[1]
              }
            })
          }))
      } else {
        $scope.systemVersion()
        $scope.available_edge_event_settings = angular.copy(deviceEventSettings)
        $scope.available_edge_event_settings.forEach(function (t, i) {
          $scope.available_edge_event_settings[i].status = false
          $scope.available_edge_event_settings[i].triggers = {}
          $scope.available_edge_event_settings[i].speed_limit = -1
          if ($scope.available_edge_event_settings[i].defaultConfiguration) {
            Object.assign($scope.available_edge_event_settings[i], {
              config: t.defaultConfiguration
            })
          }
          if (t.visualAlert) {
            $scope.available_edge_event_settings[i].visual_alert =
              t.visualAlert.defaultValue
          }
          if (t.audioAlert) {
            $scope.available_edge_event_settings[i].audio_alert =
              t.audioAlert.defaultValue
          }
          if (t.numberOfBeeps) {
            $scope.available_edge_event_settings[i].numberOfBeeps.value =
              t.numberOfBeeps.defaultValue
          }
          if (t.minimumSpeed) {
            $scope.available_edge_event_settings[i].minimumSpeed.value =
              t.minimumSpeed.defaultValue
          }
        })
      }
      $scope.mode = {}
      $scope.mode.isEditMode = false
      $scope.searchLocations = function (query) {
        return nominatimLookUp.querySearch(query)
      }
      $scope.updateEdgeCalibrateAccelerometer = function () {
        let bulk
        if (
          dataFromCaller &&
          dataFromCaller.isBulkDeviceSelection &&
          dataFromCaller.bulkDevicesSelections
        ) {
          const bulkDeviceSelection = dataFromCaller.bulkDevicesSelections
          bulk = {
            imeis: bulkDeviceSelection.serialNumbers,
            groups: bulkDeviceSelection.groups
              .filter(group => group.groupId && group.groupId !== -1)
              .map(group => group.groupId),
            ungrouped:
              bulkDeviceSelection.groups &&
              bulkDeviceSelection.groups[0] &&
              bulkDeviceSelection.groups[0].groupId === -1
          }
        } else {
          bulk = {
            imeis: [$scope.serialNumber],
            ungrouped: false
          }
        }

        const requestJson = {
          method: 'post',
          url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/devices/calibrate-accelerometer`,
          data: bulk
        }
        $http(requestJson).then(
          function () {
            alert('calibration request successfully sent')
          },
          function (err) {
            console.error(err)
            if (err && err.data && err.data.message) {
              alert('Failed sending calibration request: ' + err.data.message)
            } else {
              alert('failed sending calibration request')
            }
          }
        )
      }
      $scope.updateEdgeSettings = function () {
        const speedLimitSetting = $scope.available_edge_event_settings.find(
          item => item.name === 'SpeedLimit'
        )
        if (
          speedLimitSetting.status !== 'off' &&
          !/^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$/.test(
            speedLimitSetting.speed_limit
          )
        ) {
          return $scope.showMessageToast(
            $translate('insertValidSpeedLimitValue')
          )
        }
        const possibleFatigueSettings = $scope.available_edge_event_settings.find(
          item => item.name === 'possibleFatigue'
        )
        if (
          possibleFatigueSettings &&
          possibleFatigueSettings.status !== 'off' &&
          !/^((0|[1-9]|1[0-9]|20))$/.test(
            possibleFatigueSettings.driving_duration
          )
        ) {
          return $scope.showMessageToast(
            $translate('insertValidDrivingDurationLimitValue')
          )
        }
        const tailgatingSetting = $scope.available_edge_event_settings.find(
          item => item.name === 'tailgating'
        )
        if (tailgatingSetting && tailgatingSetting.status !== 'off') {
          if (
            !/^[1-9]\d*$/.test(
              tailgatingSetting.config.headway_alert_day_threshold
            )
          ) {
            return $scope.showMessageToast(
              $translate('insertValidTimeToCollisionDuringDayValue')
            )
          }
          if (
            !/^[1-9]\d*$/.test(
              tailgatingSetting.config.headway_alert_night_threshold
            )
          ) {
            return $scope.showMessageToast(
              $translate('insertValidTimeToCollisionDuringNightValue')
            )
          }
          if (!/^[1-9]\d*$/.test(tailgatingSetting.config.headway_alert_time)) {
            return $scope.showMessageToast(
              $translate('insertValidContinuousTimeToCollisionValue')
            )
          }
        }
        const laneWeavingSetting = $scope.available_edge_event_settings.find(
          item => item.name === 'lane_weaving'
        )
        if (laneWeavingSetting && laneWeavingSetting.status !== 'off') {
          if (
            !/^[1-9]\d*$/.test(laneWeavingSetting.config.lane_weaving_times)
          ) {
            return $scope.showMessageToast(
              $translate('insertValidLaneWeavingTimesValue')
            )
          }
          if (
            !/^[1-9]\d*$/.test(
              laneWeavingSetting.config.lane_weaving_duration_seconds
            )
          ) {
            return $scope.showMessageToast(
              $translate('insertValidLaneWeavingDurationSecondsValue')
            )
          }
        }
        const yawnSettings = $scope.available_edge_event_settings.find(
          item => item.name === 'yawn'
        )
        if (yawnSettings && yawnSettings.status !== 'off') {
          if (!/^[0-9]\d*$/.test(yawnSettings.config.timeWindow)) {
            return $scope.showMessageToast(
              $translate('insertValidTimeWindowValue')
            )
          }
          if (!/^[1-9]\d*$/.test(yawnSettings.config.numberOfYawns)) {
            return $scope.showMessageToast(
              $translate('insertValidNumberOfYawnsValue')
            )
          }
          if (
            yawnSettings.config.timeWindow === 0 &&
            yawnSettings.config.numberOfYawns > 1
          ) {
            return $scope.showMessageToast(
              $translate('insertValidTimeWindowAndNumberOfYawnsValue')
            )
          }
        }
        for (const eventSetting of $scope.available_edge_event_settings) {
          if (eventSetting.status != 'off') {
            if (
              eventSetting.numberOfBeeps &&
              eventSetting.isNumberOfBeepsAvailable
            ) {
              const numberOfBeepsValue = +eventSetting.numberOfBeeps.value
              if (!(numberOfBeepsValue >= 1 && numberOfBeepsValue <= 6)) {
                return $scope.showMessageToast(
                  $translate('insertValidNumberOfBeepsValue')
                )
              }
            }
            if (
              eventSetting.minimumSpeed &&
              eventSetting.isMinimumSpeedAvailable
            ) {
              const minimumSpeedValue = +eventSetting.minimumSpeed.value
              if (
                !Number.isInteger(minimumSpeedValue) ||
                !(minimumSpeedValue >= 0 && minimumSpeedValue <= 180)
              ) {
                const invalidMinSpeedErrorMessage = $translate(
                  'minSpeedEventSettingValidationError'
                )
                const eventSettingName = $translate(eventSetting.translate_name)
                const formatedInvalidMinSpeedErrorMessage = window.messageFormatter(
                  invalidMinSpeedErrorMessage,
                  [eventSettingName]
                )
                return $scope.showMessageToast(
                  formatedInvalidMinSpeedErrorMessage
                )
              }
            }
          }
        }
        if ($localStorage.userDetails.permission_role !== 'user') {
          const eventTriggers = $scope.available_edge_event_settings
            .filter(
              eventSetting =>
                eventSetting.configure.setEventAction ||
                eventSetting.name === 'GeoFence'
            )
            .reduce((_eventTriggers, eventSetting) => {
              if (eventSetting.name === 'GeoFence') {
                eventSetting.status = 'none'
              }

              return eventSetting.status !== 'off' &&
                eventSetting.name !== 'virtual_event'
                ? [
                    ..._eventTriggers,
                    {
                      trigger_type: eventSetting.name,
                      data_type: eventSetting.status,
                      ...(eventSetting.isSpeedLimit && {
                        speed_limit:
                          Math.ceil(eventSetting.speed_limit) *
                          ($localStorage.measurementUnits === 1 ? 1.609 : 1)
                      }),
                      ...(eventSetting.isPossibleFatigue && {
                        driving_duration: eventSetting.driving_duration
                      }),
                      ...(eventSetting.name === 'tailgating' && {
                        config: eventSetting.config
                      }),
                      ...(eventSetting.name === 'lane_weaving' && {
                        config: eventSetting.config
                      }),
                      ...(eventSetting.name === 'yawn' && {
                        config: eventSetting.config
                      }),
                      ...(eventSetting.isAudioAlertAvailable && {
                        audio_alert: eventSetting.audio_alert
                          ? eventSetting.audio_alert
                          : false
                      }),
                      ...(eventSetting.isVisualAlertAvailable && {
                        visual_alert: eventSetting.visual_alert
                          ? eventSetting.visual_alert
                          : false
                      }),
                      ...(eventSetting.isNumberOfBeepsAvailable && {
                        numberOfBeeps:
                          eventSetting.numberOfBeeps.value !== undefined
                            ? eventSetting.numberOfBeeps.value
                            : eventSetting.numberOfBeeps.defaultValue
                      }),
                      ...(eventSetting.isMinimumSpeedAvailable && {
                        minimumSpeed:
                          eventSetting.minimumSpeed.value !== undefined
                            ? Math.floor(
                                Math.ceil(eventSetting.minimumSpeed.value) *
                                  ($localStorage.measurementUnits === 1
                                    ? 1.609
                                    : 1)
                              )
                            : Math.floor(
                                Math.ceil(
                                  eventSetting.minimumSpeed.defaultValue
                                ) *
                                  ($localStorage.measurementUnits === 1
                                    ? 1.609
                                    : 1)
                              )
                      })
                    }
                  ]
                : _eventTriggers
            }, [])
          const triggers = [
            {
              trigger_type: 'VehicleSettings',
              vehicle_type: $scope.vehicleType.value
            },
            ...eventTriggers
          ]
          isBulkDeviceSelection
            ? saveBulkTriggers(triggers)
            : saveTriggers(triggers)
        } else {
          $mdDialog.cancel()
          $scope.showMessageToast($translate('accessDenied'))
        }
      }

      const saveTriggers = triggers => {
        const triggersConfig = {
          message_type: 'trigger_config',
          triggers: triggers
        }
        const requestJson = {
          method: 'PUT',
          url: `${DEVICEMANAGER_BASEURL}/device/${$scope.serialNumber}/trigger_config`,
          data: triggersConfig
        }
        $http(requestJson)
          .then(function (result) {
            if (result.data.status.code === 0) {
              $mdDialog.hide()
            }
          })
          .catch(ex => {
            $scope.showMessageToast(ex.data.message)
            console.error(ex)
          })
      }
      const saveBulkTriggers = triggers => {
        const triggersConfig = {
          message_type: 'trigger_config',
          triggers: triggers
        }
        const requestData = {
          bulkDevicesSelections,
          triggersConfig,
          suppressYawnErrors: true
        }
        const requestJson = {
          method: 'PUT',
          url: `${DEVICEMANAGER_BASEURL}/device/bulk/trigger-config`,
          data: requestData
        }
        $http(requestJson)
          .then(function (result) {
            if (result.data.status.code === 0) {
              $mdDialog.hide()
            }
          })
          .catch(error => {
            handleServerError(error)
            $scope.showMessageToast(error.data.message)
            console.log(error)
          })
      }
      /* Event Email notification settings */
      $scope.showEventEmailConfig = function (edgeSetting) {
        $scope.selectedTab = 1
        $scope.selectedEdgeSetting = angular.copy(edgeSetting)
        $scope.selectedEdgeSetting.emailRecipients = []
        $scope.newRecipient = {
          email: ''
        }
        if (!isBulkDeviceSelection) {
          $scope.loadEventEmailRecipients()
        }
      }

      /* Event Optional Parameters configuration */
      $scope.showEventOptionalParameters = function (edgeSetting) {
        $scope.selectedTab = 2
        $scope.selectedEdgeSetting = angular.copy(edgeSetting)
        $scope.loadEventOptionalParameters()
      }
      $scope.loadEventOptionalParameters = function () {
        $scope.selectedEdgeSetting.optionalParametersLoading = true
        let requestJson
        switch ($scope.selectedEdgeSetting.name) {
          case 'distracted_driving':
            requestJson = {
              method: 'GET',
              url: `${EDGE_BASEURL}/rpc-distracted/${$scope.edge.imei}`
            }
            break
          default:
            break
        }
        $http(requestJson)
          .then(
            response => {
              $scope.selectedEdgeSetting.optionalParametersLoading = false
              if (
                response &&
                response.data &&
                response.data.status.code === 0
              ) {
                $scope.selectedEdgeSetting.optionalParameters = {
                  EVENT_ANY_DISTRACTION:
                    response.data.data.config.EVENT_ANY_DISTRACTION,
                  trigger_delay: response.data.data.trigger_delay
                }
              }
            },
            () => {
              $scope.selectedEdgeSetting.optionalParametersLoading = false
            }
          )
          .catch(error => {
            handleServerError(error)
            $scope.showEventSettings()
          })
      }
      $scope.saveEventOptionalParameters = function () {
        let requestJson
        switch ($scope.selectedEdgeSetting.name) {
          case 'distracted_driving':
            requestJson = {
              method: 'POST',
              url: `${EDGE_BASEURL}/rpc-distracted/${$scope.edge.imei}`,
              data: {
                config: {
                  EVENT_ANY_DISTRACTION:
                    $scope.selectedEdgeSetting.optionalParameters
                      .EVENT_ANY_DISTRACTION
                },
                trigger_delay:
                  $scope.selectedEdgeSetting.optionalParameters.trigger_delay
              }
            }
            break
          default:
            return
        }
        $http(requestJson)
          .then(response => {
            if (response.data.status.code === 0 && response.data.requestId) {
              $scope.showMessageToast(
                $translate('eventOptionalParametersSaved')
              )
            } else {
              $scope.available_edge_event_settings[
                $scope.selectedEdgeSetting.index
              ].showOptions = false
              $scope.showMessageToast(
                $translate('thisDeviceCannotBeConfiguredInOfflineMode')
              )
            }
          })
          .catch(error => {
            handleServerError(error)
          })
          .finally(() => {
            $scope.showEventSettings()
          })
      }

      $scope.loadEventEmailRecipients = function () {
        $scope.selectedEdgeSetting.emailRecipientsLoading = true
        const requestJson = {
          method: 'POST',
          url: `${EDGE_BASEURL}/edge/${$scope.edge.imei}/notificationRecipients`,
          data: {
            msgType: $scope.selectedEdgeSetting.name,
            recipientType: 'email',
            cameraSerial: $scope.edge.imei
          }
        }
        $http(requestJson).then(
          function (response) {
            $scope.selectedEdgeSetting.emailRecipientsLoading = false
            if (response.data.status.code === 0) {
              $scope.selectedEdgeSetting.emailRecipients =
                response.data.dashcamNotificationRecipients.recipients
            }
          },
          function () {
            $scope.selectedEdgeSetting.emailRecipientsLoading = false
          }
        )
      }
      $scope.addEventEmailRecipient = function (form) {
        const alreadyExists = $scope.selectedEdgeSetting.emailRecipients.some(
          e =>
            e.recipient.toLowerCase() ===
            $scope.newRecipient.email.toLowerCase()
        )
        if (alreadyExists) {
          $scope.showMessageToast('Email already exists')
          return
        }
        $scope.selectedEdgeSetting.emailRecipients.push({
          recipient: $scope.newRecipient.email.toLowerCase(),
          status: 1
        })
        $scope.newRecipient.email = ''
        $timeout(function () {
          form.$setUntouched()
        })
      }
      $scope.deleteEventEmailRecipient = function (index) {
        $scope.selectedEdgeSetting.emailRecipients.splice(index, 1)
      }
      $scope.saveEventEmailRecipients = async () => {
        if (isBulkDeviceSelection) {
          const requestJson = {
            method: 'PUT',
            url: `${V2_BASEURL}/devices/events/${$scope.selectedEdgeSetting.v2Name}/notification-recipients`,
            data: {
              notificationRecipients: $scope.selectedEdgeSetting.emailRecipients.map(
                ({ recipient }) => recipient
              )
            }
          }
          try {
            const groupIds = bulkDevicesSelections.groups.map(
              group => group.groupId
            )
            await Promise.all([
              ...(groupIds.length
                ? [
                    $http({
                      ...requestJson,
                      data: {
                        ...requestJson.data,
                        organizationId: $rootScope.currentUserOrganization.id,
                        groupIds
                      }
                    })
                  ]
                : []),
              ...(bulkDevicesSelections.serialNumbers.length
                ? [
                    $http({
                      ...requestJson,
                      data: {
                        ...requestJson.data,
                        imeis: bulkDevicesSelections.serialNumbers
                      }
                    })
                  ]
                : [])
            ])
            $scope.showMessageToast(
              $translate('eventEmailNotificationsConfigSaved')
            )
            $scope.showEventSettings()
            $scope.$apply()
          } catch (ex) {
            console.error(ex)
          }
        } else {
          const requestJson = {
            method: 'PUT',
            url: `${EDGE_BASEURL}/edge/${$scope.edge.imei}/notificationRecipients`,
            data: {
              msgType: $scope.selectedEdgeSetting.name,
              recipientType: 'email',
              recipients: $scope.selectedEdgeSetting.emailRecipients,
              cameraSerial: $scope.edge.imei
            }
          }
          $http(requestJson).then(
            function (response) {
              $scope.selectedEdgeSetting.emailRecipientsLoading = false
              if (response.data.status.code === 0) {
                $scope.showMessageToast(
                  $translate('eventEmailNotificationsConfigSaved')
                )
                $scope.showEventSettings()
              }
            },
            function () {
              $scope.selectedEdgeSetting.emailRecipientsLoading = false
            }
          )
        }
      }
      $scope.showEventSettings = function () {
        $scope.selectedTab = 0
        $scope.selectedEdgeSetting = null
      }
      $scope.showMessageToast = function (message) {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .actionKey('F1')
          .position('bottom')
          .parent('#edge-event-setting-container')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
      $scope.shouldHaveMedia = v2EventTypeName =>
        !defaultEventConfig.noMediaV2EventTypesByDeviceModel.common.includes(
          v2EventTypeName
        ) &&
        ($scope.isBulkDeviceSelection ||
          !defaultEventConfig.noMediaV2EventTypesByDeviceModel[
            $scope.edge.deviceModel
          ].includes(v2EventTypeName))

      function handleServerError (response) {
        $scope.$emit('handleServerError', response)
      }
      $scope.onChangeDataType = edgeSettings => {
        if (edgeSettings.status === 'off') {
          if (edgeSettings.isSpeedLimit) {
            edgeSettings.speedLimit = edgeSettings.speed_limit
          }
          if (edgeSettings.isVisualAlertAvailable) {
            edgeSettings.visualAlert.value = !edgeSettings.visualAlert
              .defaultValue
          }
          if (edgeSettings.isAudioAlertAvailable) {
            edgeSettings.audioAlert.value = !edgeSettings.audioAlert
              .defaultValue
          }
          if (
            edgeSettings.isNumberOfBeepsAvailable &&
            semanticVersion &&
            SemverSatifies(
              semanticVersion,
              edgeSettings.numberOfBeeps.versionRanges
            )
          ) {
            edgeSettings.isNumberOfBeepsAvailable = false
          }
          if (
            edgeSettings.isMinimumSpeedAvailable &&
            semanticVersion &&
            SemverSatifies(
              semanticVersion,
              edgeSettings.minimumSpeed.versionRanges
            )
          ) {
            edgeSettings.isMinimumSpeedAvailable = false
          }
        } else {
          // show number of beeps drop down when event status is not set to off
          if (
            edgeSettings.numberOfBeeps &&
            semanticVersion &&
            SemverSatifies(
              semanticVersion,
              edgeSettings.numberOfBeeps.versionRanges
            )
          ) {
            const {
              allowedValueRange,
              incrementBy
            } = edgeSettings.numberOfBeeps
            const allowedValues = window.getRange(
              allowedValueRange[0],
              allowedValueRange[1],
              incrementBy
            )
            edgeSettings.numberOfBeeps.allowedValues = allowedValues
            edgeSettings.numberOfBeeps.value =
              edgeSettings.numberOfBeeps.value ||
              edgeSettings.numberOfBeeps.defaultValue
            edgeSettings.isNumberOfBeepsAvailable = true
          }

          // show min speed drop down when event status is not set to off
          if (
            edgeSettings.minimumSpeed &&
            semanticVersion &&
            SemverSatifies(
              semanticVersion,
              edgeSettings.minimumSpeed.versionRanges
            )
          ) {
            const { allowedValueRange } = edgeSettings.minimumSpeed
            edgeSettings.minimumSpeed.minValue = allowedValueRange[0]
            edgeSettings.minimumSpeed.maxValue = allowedValueRange[1]
            edgeSettings.minimumSpeed.value =
              edgeSettings.minimumSpeed.value ||
              edgeSettings.minimumSpeed.defaultValue
            edgeSettings.isMinimumSpeedAvailable = true
          }
        }
      }
      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'
      const loadADASCalibrationData = async serialNumber => {
        try {
          const requestJson = {
            method: 'GET',
            url: `${DEVICE_BASEURL}/device-health?device_id=${serialNumber}`
          }
          return await $http(requestJson)
        } catch (error) {
          handleServerError(error)
        } finally {
          $scope.loading = false
        }
      }
    }
  ])
